
$(function () {
    $.fn.extend({
        rotateText: function (options) {

            var defaults = {
                fadeSpeed: 500,
                pauseSpeed: 100,
                infiniteScroll: false,
                child: null
            };

            var options = $.extend(defaults, options);

            return this.each(function () {
                var o = options;
                var obj = $(this);
                var items = $(obj.children(), obj);

                // iterate through all items in this banner and hide them initially
                items.each(function () {
                    $(this).hide();
                })

                if (!o.child) {
                    var next = $(obj).children(':first');
                } else {
                    var next = o.child;
                }

                $(next).fadeIn(o.fadeSpeed, function () {
                    if (!o.infiniteScroll && $(this).next().length == 0) {
                        return false;
                    } else {
                        $(next).delay(o.pauseSpeed).fadeOut(o.fadeSpeed, function () {
                            var next = $(this).next();
                            if (next.length == 0) {
                                next = $(obj).children(':first');
                            }
                            $(obj).rotateText({ child: next, fadeSpeed: o.fadeSpeed, pauseSpeed: o.pauseSpeed, infiniteScroll: o.infiniteScroll });
                        })
                    }
                });
            });
        }
    });
});

$(document).ready(function () {
    $('.rotate-text').each(function () {
        var speed = $(this).data('scroll-speed');
        var pause = $(this).data('scroll-pause');
        var infinite = $(this).data('scroll-infinite');
        $(this).rotateText({ fadeSpeed: speed, pauseSpeed: pause, infiniteScroll: infinite });
    });
});